<template>
    <div
        class="t-lk-date-input__container t-filter__class"
        @click="clickDate"
        :class="{_btn: isBtn}"
    >
        <div v-if="!isBtn" class="t-lk-date__title t-lk-date-input js-filter-date-item">
            <input
                v-if="!UNSAFE_disabledInput"
                v-model="dateText"
                class="t-lk-date-input__text"
                :placeholder="$root.staticText.filter.choose2"
                readonly
            >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.44444 7.55556V4V7.55556ZM15.5556 7.55556V4V7.55556ZM7.55556 11.1111H16.4444H7.55556ZM5.77778 20H18.2222C18.6937 20 19.1459 19.8127 19.4793 19.4793C19.8127 19.1459 20 18.6937 20 18.2222V7.55556C20 7.08406 19.8127 6.63187 19.4793 6.29848C19.1459 5.96508 18.6937 5.77778 18.2222 5.77778H5.77778C5.30628 5.77778 4.8541 5.96508 4.5207 6.29848C4.1873 6.63187 4 7.08406 4 7.55556V18.2222C4 18.6937 4.1873 19.1459 4.5207 19.4793C4.8541 19.8127 5.30628 20 5.77778 20Z" stroke="#00b0bd" stroke-width="1.77778" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div
            v-else
            class="t-lk-leads-work__btn t-btn _green _lk js-filter-date-item"
        >
            {{ btnText }}
        </div>

        <template v-if="visibleDatePicker">
            <portal to="portal" v-if="isMobile">
                <div class="t-modal js-modal _lk">
                    <div class="t-modal__container">
                        <div class="t-lk-modal__content t-filter__class">
                        <h2 class="t-lk-modal__title">{{ this.$root.staticText.lk.leadsStatus3 }}</h2>
            
                            <div class="js-date-picker t-lk-date-picker _modal-mobile">
                                <v-date-picker
                                    v-model="dates"
                                    :first-day-of-week="1"
                                    @input="changeDate"
                                    :allowed-dates="disablePastDates"
                                    :locale="$router.history.base !== '' ? $router.history.base.substring(1) : 'ru'"
                                    no-title
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </portal>
    
            <transition name="fade" v-else>
                <div
                    class="t-filter__date-picker js-date-picker t-lk-date-picker"
                    @click.stop.prevent=""
                >
                    <v-date-picker
                        v-model="dates"
                        :first-day-of-week="1"
                        @input="changeDate"
                        :allowed-dates="disablePastDates"
                        :locale="$router.history.base !== '' ? $router.history.base.substring(1) : 'ru'"
                        no-title
                    >
                    </v-date-picker>
                </div>
            </transition>
        </template>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

    export default {
        name: "lk-date-lead",
        props: {
            UNSAFE_disabledInput: {
                type: Boolean,
                default: false
            },
            isBtn: {
                type: Boolean,
                default: false,
            },
            item: Object,
            index: Number,
            isDefaultOpened: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
                default: window.staticText.filter.choose2
            },
            btnText: {
                tyoe: String,
                default: window.staticText.lk.leadsWorkBtn3,
            }
        },
        data() {
            return {
                visibleDatePicker: false,
                dates: '',
                prevDates: '',
            }
        },

        computed: {
            ...mapState('mobile', {
                isMobile: state => state.isMobile
            }),
            dateText() {
                const [ yyyy, mm, dd ] = this.dates.split('-');
                return `${dd}.${mm}.${yyyy}`;
            },
        },
        methods: {
            ...mapMutations({
                lk_setItemLead: 'lk/leads/setItemLead',
                portal_setIsOpened: 'portal/setIsOpened'
            }),
            disablePastDates(val) {
                const currentDate = new Date();

                const [
                    dd,
                    mm,
                    yyyy
                ] = [
                    currentDate.getDate(),
                    currentDate.getMonth(),
                    currentDate.getFullYear()
                ]
                return val > new Date(yyyy, mm, dd + 1).toISOString().substring(0, 10);
            },
            clickDate() {
                this.visibleDatePicker = !this.visibleDatePicker;
                if (this.isMobile) this.portal_setIsOpened(true);
            },
            changeDate() {
                // закрываем календарь
                this.visibleDatePicker = false;
                this.portal_setIsOpened(false);
                
                // TODO: вынести в нормалный стор
                // в итоге просто заимитил событие чтоб в компоненте родителе все дела делать
                this.$emit("change:date", {
                    date: this.dates,
                    prevDate: this.prevDates
                })
                return
            },
            clickOutFilter(e) {
                if (
                    e.target.closest('.js-filter-date-item') ||
                    e.target.closest('.js-date-picker')
                ) return;

                this.visibleDatePicker = false;
                this.portal_setIsOpened(false);

                if (!this.item.noConfirm) return;
                
                if (this.$route.name !== 'lk-leads') {
                    this.$emit('set-status', 1)
                    return;
                }

                this.lk_setItemLead({
                    id: this.item.id,
                    name: 'status',
                    value: 1
                });
            }
        },
        created() {
            const [ dd, mm, yyyy ] = this.item.dateDeal.split('.');
            
            this.dates = (`${yyyy}-${mm}-${dd}`);
            this.prevDates = (`${yyyy}-${mm}-${dd}`);
        },
        mounted() {
            window.addEventListener('click', this.clickOutFilter);

            this.visibleDatePicker = this.isDefaultOpened;
            if (this.isMobile) this.portal_setIsOpened(this.isDefaultOpened);
        },
        beforeDestroy() {
            window.removeEventListener('click', this.clickOutFilter);
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/lk/lk-date-lead/lk-date-lead.vue